import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSketchbook: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSketchbook"><Path d="M4 3V21H20V3H4Z" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 7.5H15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 11.5H12.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSketchbook;
